export default {
  'supportChat.title': 'Por favor, escriba su mensaje',
  'supportChat.subTitle': '¡Los agentes están en línea!',
  'supportChat.button': 'Soporte en línea ¡Estamos muy cerca de ti!',
  'supportChat.placeholder': 'Escribe tu mensaje...',
  'supportChat.you': 'Tú',
  'supportChat.voiceMessage': 'Mensaje de voz',
  'supportChat.audioNotAvailable': 'Audio no disponible para reproducción',
  'supportChat.copy': 'Copiar',
  'supportChat.copied': '¡Copiado!',
  'supportChat.codeCopied': 'Código copiado al portapapeles',
  'supportChat.copyError': 'Error al copiar código',
  'supportChat.attachedFile': 'Archivo adjunto',
  'supportChat.recording': 'Grabando',
  'supportChat.browserNotSupported': 'Tu navegador no soporta el elemento de audio.',
  'supportChat.send': 'Enviar mensaje',
  'supportChat.attachment': 'Agregar adjunto',
  'supportChat.fileUpload': 'Subir archivo',
  'supportChat.recordAudio': 'Grabar audio',
  'supportChat.startRecording': 'Iniciar grabación',
  'supportChat.stopRecording': 'Detener grabación',
  'supportChat.addUrl': 'Agregar URL',
  'supportChat.newChat': 'Nuevo Chat',
  'supportChat.close': 'Cerrar chat',
  'supportChat.errorSending': 'Error al enviar el mensaje',
  'supportChat.removeAttachment': 'Eliminar adjunto',
  'supportChat.enterUrl': 'Ingrese URL',
  'supportChat.stop': 'Detener',
  'supportChat.preview': 'Vista previa',
  'supportChat.errorUploadingFile': 'Error al subir el archivo',
  'supportChat.errorProcessingFile': 'Error al procesar el archivo',
  'supportChat.headerTitle': 'AUTOMY Assistant',
  'supportChat.headerSubtitle': 'Tu agente de automatización y datos.',
  'supportChat.welcome':
    '👋 ¡Hola! Soy tu Asistente AI de AUTOMY.\nEstoy aquí para ayudarte a:\n\n• Resolver dudas 🤔\n• Automatizar procesos ⚙️\n• Analizar tus datos 📊\n• Ejecutar funciones en tiempo real 🚀\n\n¿En qué te puedo ayudar hoy?',
  'supportChat.placeholder.inspire': 'Hazme una pregunta o pídele una acción al asistente...',
  'supportChat.placeholder.inspireMobile': 'Pregunta o pide una acción...',
  'supportChat.placeholder.aiThinking': 'La IA está pensando, por favor espera...',
  'supportChat.aiThinkingBlocked': 'Por favor espera mientras la IA procesa tu mensaje anterior.',
  'supportChat.aiWarning': '⚡ Respuestas generadas por IA. Verifica siempre.',
  'supportChat.hideChat': 'Ocultar Chat',
  'supportChat.voiceMessageFileName': 'mensaje_de_voz.webm',
  'supportChat.invalidUrl': 'La URL proporcionada no es válida.',
  'supportChat.cannotAccessResource': 'No se pudo acceder al recurso en la URL proporcionada.',
  'supportChat.cannotDetermineContentType':
    'No se pudo determinar el tipo de contenido del recurso.',
  'supportChat.invalidContentType': 'El tipo de contenido no es válido.',
  'supportChat.errorGettingContentType':
    'Ocurrió un error al intentar obtener el tipo de contenido.',
  'supportChat.fileTypeNotAllowed':
    'Tipo de archivo no permitido. Solo se permiten imágenes y audios.',
  'supportChat.button.full': '¿Necesitas ayuda? Pregunta al Asistente de IA',
  'supportChat.loadingMoreMessages': 'Cargando mensajes anteriores...',
  'supportChat.loadingAgents': 'Cargando agentes...',
  'supportChat.loadMoreAgents': 'Cargar más agentes...',
  'supportChat.searchAgents': 'Buscar agentes...',
  'supportChat.noAgentsFound': 'No se encontraron agentes',
  'supportChat.status.pending': 'Pendiente',
  'supportChat.status.active': 'Activo',
  'supportChat.status.lookingForAgent': 'Buscando agente',
  'supportChat.status.closed': 'Cerrado',
  'supportChat.status.archived': 'Archivado',
  'supportChat.messageStatus.policyViolation': 'Bloqueado por moderación',
  'supportChat.messageStatus.failed': 'Mensaje no enviado',
  'supportChat.messageStatus.error': 'Error en el mensaje',
  'supportChat.messageError.title': 'No se pudo entregar el mensaje',
  'supportChat.messageError.subtitle': 'Detalles del error',
  'supportChat.moderation.title': 'Mensaje bloqueado por moderación',
  'supportChat.moderation.defaultUserMessage':
    'Este mensaje no se procesó porque infringe nuestras políticas de uso.',
  'supportChat.moderation.severityLabel': 'Severidad:',
  'supportChat.moderation.severity.hardBlock': 'Bloqueo crítico',
  'supportChat.moderation.severity.softBlock': 'Bloqueo parcial',
  'supportChat.moderation.severity.flagged': 'Marcado para revisión',
  'supportChat.moderation.severity.unknown': 'Severidad desconocida',
  'supportChat.moderation.categoriesLabel': 'Categorías detectadas:',
  'supportChat.moderation.categoryFallback': '{category}',
  'supportChat.moderation.categories.illicit': 'Contenido ilícito',
  'supportChat.moderation.categories.illicitViolent': 'Contenido ilícito violento',
  'supportChat.moderation.categories.hate': 'Discurso de odio',
  'supportChat.moderation.categories.hateThreatening': 'Amenazas de odio',
  'supportChat.moderation.categories.harassment': 'Acoso',
  'supportChat.moderation.categories.sexual': 'Contenido sexual',
  'supportChat.moderation.categories.sexualMinors': 'Contenido sexual con menores',
  'supportChat.moderation.categories.selfHarm': 'Autolesiones',
  'supportChat.moderation.categories.violence': 'Violencia',
  'supportChat.moderation.categories.violenceGraphic': 'Violencia gráfica',
  'supportChat.guardrails.urlFilter.title': 'Filtro de URL',
  'supportChat.guardrails.urlFilter.blockedTitle': 'Mensaje bloqueado por filtro de URL',
  'supportChat.guardrails.urlFilter.label': 'Filtro de URL',
  'supportChat.guardrails.urlFilter.action.block': 'URL bloqueada',
  'supportChat.guardrails.urlFilter.action.mask': 'URL enmascarada',
  'supportChat.guardrails.urlFilter.action.allow': 'URL permitida',
  'supportChat.guardrails.urlFilter.action.unknown': 'Filtro de URL aplicado',
  'supportChat.guardrails.jailbreak.title': 'Jailbreak / prompt injection',
  'supportChat.guardrails.jailbreak.badge': 'Jailbreak detectado',
  'supportChat.guardrails.jailbreak.label': 'Jailbreak',
  'supportChat.guardrails.moderation': 'Moderación',
  'supportChat.guardrails.title': 'Guardrails',
  'supportChat.guardrails.status': 'Guardrails',
  'supportChat.guardrails.jailbreak.detected': 'Jailbreak detectado',
  'supportChat.guardrails.jailbreak.notDetected': 'Jailbreak no detectado',
  'supportChat.guardrails.promptInjection.detected': 'Prompt injection detectado',
  'supportChat.guardrails.promptInjection.notDetected': 'Prompt injection no detectado',
  'supportChat.deleteThreadTitle':
    '¿Desea eliminar esta conversación? Esta acción es irreversible.',
  'supportChat.deleteThreadContent': 'Esta acción no se puede deshacer.',
  'supportChat.deleteThreadOk': 'Eliminar',
  'supportChat.deleteThreadCancel': 'Cancelar',
  'supportChat.closedChatPlaceholder':
    'Esta conversación está cerrada o archivada. Para continuar, reabra primero.',
  'supportChat.closedButAgentWorking':
    'Esta conversación está cerrada, pero el agente sigue procesando en segundo plano.',
  'supportChat.reopenChat': 'Reabrir',
  'supportChat.chatReopened': 'Chat reabierto exitosamente',
  'supportChat.closeThreadTitle': '¿Desea cerrar esta conversación? Podrá reabrirla después.',
  'supportChat.closeThreadOk': 'Cerrar',
  'supportChat.closeThreadCancel': 'Cancelar',
  'supportChat.errorCreatingNewChat': 'Error al crear nuevo chat',
  'supportChat.showThreads': 'Ver conversaciones',
  'supportChat.yesterday': 'Ayer',
  'supportChat.today': 'Hoy',
  'supportChat.loadingMoreThreads': 'Cargando más conversaciones...',
  'supportChat.noMoreThreads': 'No hay más conversaciones',
  'supportChat.errorUploadingAttachment': 'Error al subir el archivo',
  'supportChat.uploading': 'Subiendo',
  'supportChat.errorSendingMessage': 'Error al enviar mensaje',
  'supportChat.errorReopeningChat': 'Error al reabrir el chat',
  'supportChat.button.header': '✨ Asistente AI',
  'supportChat.fullscreen': 'Pantalla completa',
  'supportChat.noThreads': 'No hay conversaciones aún',
  'supportChat.thisWeek': 'Esta semana',
  'supportChat.lastMonth': 'Mes pasado',
  'supportChat.older': 'Más antiguo',
  'supportChat.connectionReestablished': 'Conexión reestablecida',
  'supportChat.connectionReestablishedWithIssue':
    'Conexión reestablecida pero hubo un problema al unirse al chat',
  'supportChat.connectionLost': 'Conexión perdida. Reintentando automáticamente...',
  'supportChat.errorSendingMessageGeneric': 'Error al enviar mensaje',
  'supportChat.noConnectionQueueMessage': 'Sin conexión. Conéctate para enviar el mensaje.',
  'supportChat.noActiveThread': 'No hay conversación activa',
  'supportChat.cannotSendToClosedThread':
    'No se pueden enviar mensajes a una conversación cerrada o archivada',
  'supportChat.socketNotAvailable': 'Servicio de chat no disponible',
  'supportChat.pendingMessagesSent': 'mensajes pendientes enviados',
  'supportChat.thinking': 'Pensando',
  'supportChat.executing': 'Ejecutando',
  'supportChat.newMessages': 'nuevo',
  'supportChat.newMessagesPlural': 'nuevos',
  'supportChat.cancelUpload': 'Cancelar subida',
  'supportChat.cleaningFile': 'Limpiando archivo...',

  // Tooltips para botones de conversación
  'supportChat.editThread': 'Editar',
  'supportChat.closeThread': 'Cerrar',
  'supportChat.deleteThread': 'Eliminar',

  // Claves para tareas programadas
  'supportChat.showTasks': 'Ver tareas',
  'supportChat.showEmails': 'Correos',
  'supportChat.noEmails': 'No hay emails para este hilo',
  'supportChat.loadingEmails': 'Cargando emails...',
  'supportChat.emailFrom': 'De',
  'supportChat.emailTo': 'Para',
  'supportChat.emailResponse.success': 'Entregado',
  'supportChat.backToChat': 'Volver al chat',
  'supportChat.noTasks': 'No hay tareas programadas aún',
  'supportChat.loadingMoreTasks': 'Cargando más tareas...',
  'supportChat.noMoreTasks': 'No hay más tareas',
  'supportChat.executeTask': 'Ejecutar Tarea',
  'supportChat.pauseTask': 'Pausar Tarea',
  'supportChat.resumeTask': 'Reanudar Tarea',
  'supportChat.taskHistory': 'Historial',
  'supportChat.deleteTask': 'Eliminar Tarea',
  'supportChat.taskExecuted': 'Tarea ejecutada exitosamente',
  'supportChat.taskPaused': 'Tarea pausada',
  'supportChat.taskResumed': 'Tarea reanudada',
  'supportChat.taskDeleted': 'Tarea eliminada',
  'supportChat.deleteTaskTitle': '¿Desea eliminar esta tarea? Esta acción es irreversible.',
  'supportChat.deleteTaskOk': 'Eliminar',
  'supportChat.deleteTaskCancel': 'Cancelar',
  'supportChat.taskStatus.pending': 'Pendiente',
  'supportChat.taskStatus.active': 'Activa',
  'supportChat.taskStatus.paused': 'Pausada',
  'supportChat.taskStatus.completed': 'Completada',
  'supportChat.taskStatus.failed': 'Fallida',
  'supportChat.scheduledFor': 'Programada para',
  'supportChat.repeatEvery': 'Se repite cada',
  'supportChat.maxOccurrences': 'Máximo de ejecuciones',
  'supportChat.unlimited': 'Ilimitado',
  'supportChat.errorExecutingTask': 'Error al ejecutar la tarea',
  'supportChat.errorPausingTask': 'Error al pausar la tarea',
  'supportChat.errorResumingTask': 'Error al reanudar la tarea',
  'supportChat.errorDeletingTask': 'Error al eliminar la tarea',
  'supportChat.taskFrequency.minute': 'minuto(s)',
  'supportChat.taskFrequency.hour': 'hora(s)',
  'supportChat.taskFrequency.day': 'día(s)',
  'supportChat.taskFrequency.week': 'semana(s)',
  'supportChat.taskFrequency.month': 'mes(es)',

  // Tareas programadas (estados actualizados según enum del backend)
  'supportChat.taskStatus.pending': 'Pendiente',
  'supportChat.taskStatus.processing': 'Procesando',
  'supportChat.taskStatus.processed': 'Procesada',
  'supportChat.taskStatus.error': 'Error',
  'supportChat.taskStatus.skipped': 'Omitida',
  'supportChat.taskStatus.cancelled': 'Cancelada',
  'supportChat.taskStatus.failed': 'Fallida',

  'supportChat.taskFrequency.daily': 'días',
  'supportChat.taskFrequency.weekly': 'semanas',
  'supportChat.taskFrequency.monthly': 'meses',
  'supportChat.taskFrequency.yearly': 'años',
  'supportChat.taskFrequency.minutes': 'minutos',
  'supportChat.taskFrequency.hours': 'horas',

  'supportChat.viewTaskRuns': 'Ver historial de ejecuciones',

  'supportChat.taskExecuted': 'Tarea ejecutada correctamente',
  'supportChat.taskPaused': 'Tarea pausada correctamente',
  'supportChat.taskResumed': 'Tarea reanudada correctamente',
  'supportChat.taskDeleted': 'Tarea eliminada correctamente',

  'supportChat.errorExecutingTask': 'Error al ejecutar la tarea',
  'supportChat.errorPausingTask': 'Error al pausar la tarea',
  'supportChat.errorResumingTask': 'Error al reanudar la tarea',
  'supportChat.errorDeletingTask': 'Error al eliminar la tarea',

  'supportChat.deleteTaskTitle': '¿Eliminar tarea?',
  'supportChat.deleteTaskOk': 'Eliminar',
  'supportChat.deleteTaskCancel': 'Cancelar',

  'supportChat.repeatEvery': 'Repetir cada',
  'supportChat.maxOccurrences': 'Máximo de ejecuciones',
  'supportChat.unlimited': 'Sin límite',

  'supportChat.noTasks': 'No hay tareas programadas',
  'supportChat.loadingMoreTasks': 'Cargando más tareas...',
  'supportChat.noMoreTasks': 'No hay más tareas para mostrar',

  // Historial de runs
  'supportChat.taskRuns': 'Historial de Ejecuciones',
  'supportChat.backToTasks': 'Volver a Tareas',
  'supportChat.taskRunsFor': 'Historial de ejecuciones para',
  'supportChat.noRuns': 'No hay ejecuciones para esta tarea',
  'supportChat.loadingMoreRuns': 'Cargando más ejecuciones...',
  'supportChat.noMoreRuns': 'No hay más ejecuciones para mostrar',

  'supportChat.runStatus.pending': 'Pendiente',
  'supportChat.runStatus.processing': 'Procesando',
  'supportChat.runStatus.processed': 'Procesada',
  'supportChat.runStatus.error': 'Error',
  'supportChat.runStatus.skipped': 'Omitida',
  'supportChat.runStatus.cancelled': 'Cancelada',
  'supportChat.runStatus.failed': 'Falló',
  'supportChat.runStatus.unknown': 'Desconocido',

  'supportChat.duration': 'Duración',
  'supportChat.output': 'Resultado',

  // Nuevos tipos de contenido
  'supportChat.taskExecution': 'Ejecución de Tarea',
  'supportChat.viewDetails': 'Ver Detalles',
  'supportChat.hideDetails': 'Ocultar',
  'supportChat.audioFromUrl': 'Audio desde URL',

  // Multi-agent support
  'supportChat.loadingAgents': 'Cargando agentes...',
  'supportChat.selectAgent': 'Seleccionar agente',
  'supportChat.documentFromUrl': 'Documento desde URL',
  'supportChat.imageFromUrl': 'Imagen desde URL',
  'supportChat.image': 'Imagen',
  'supportChat.openInMaps': 'Abrir en Google Maps',
  'supportChat.location': 'Ubicación',
  'supportChat.phone': 'Teléfono',
  'supportChat.email': 'Correo',

  // Opciones de copiar y exportar mensajes
  'supportChat.copyMessage': 'Copiar mensaje',
  'supportChat.exportMessage': 'Exportar mensaje',
  'supportChat.export': 'Exportar',
  'supportChat.reply': 'Responder',
  'supportChat.replyMessage': 'Responder a este mensaje',
  'supportChat.replyingTo': 'Respondiendo a',
  'supportChat.inReplyTo': 'En respuesta a',
  'supportChat.messagePreviewNotAvailable': 'Vista previa no disponible',
  'supportChat.messageContent': 'Contenido del mensaje',
  'supportChat.clickToGoToMessage': 'Haz clic para ir al mensaje original',
  'supportChat.cancelReply': 'Cancelar respuesta',
  'supportChat.you': 'Tú',
  'supportChat.automy': 'AUTOMY',
  'supportChat.messageCopied': 'Mensaje copiado al portapapeles',
  'supportChat.messageExported': 'Mensaje exportado exitosamente',
  'supportChat.copyError': 'Error al copiar el mensaje',
  'supportChat.exportError': 'Error al exportar el mensaje',

  // Human agent events
  'supportChat.humanAgentAssigned': 'Un agente humano fue asignado a tu chat.',
  'supportChat.humanAgentAssignedWithName': 'Agente {name} asignado a tu chat.',
  'supportChat.transferToHuman': 'Transferir a soporte',
  'supportChat.transferToAI': 'Transferir a IA',
  'supportChat.transferToAI.error': 'No se pudo transferir el chat a IA',
  'supportChat.transferToHuman.error': 'No se pudo transferir el chat a soporte',
  'supportChat.contacts': 'Contactos',
  'supportChat.contacts.loadError': 'Error al cargar los contactos',
  'supportChat.noContacts': 'No se encontraron contactos para este thread',
  'supportChat.contact.edit': 'Editar contacto',
  'supportChat.contact.delete': 'Eliminar contacto',
  'supportChat.contact.deleteTitle': 'Eliminar contacto',
  'supportChat.contact.deleteContent': '¿Deseas eliminar a {name} de este thread?',
  'supportChat.contact.deleteSuccess': 'Contacto eliminado exitosamente',
  'supportChat.contact.deleteError': 'Error al eliminar el contacto',
  'supportChat.contact.updateSuccess': 'Contacto actualizado exitosamente',
  'supportChat.contact.updateError': 'Error al actualizar el contacto',
  'supportChat.contact.noChanges': 'No hay cambios para guardar',
  'supportChat.contact.noEditableFields': 'Este contacto no tiene campos editables',
  'supportChat.contact.unnamed': 'Contacto sin nombre',
  'supportChat.contact.field.fullName': 'Nombre completo',
  'supportChat.contact.field.name': 'Nombre',
  'supportChat.contact.field.email': 'Correo electrónico',
  'supportChat.contact.field.phone': 'Teléfono',
  'supportChat.contact.field.phoneNumber': 'Número de teléfono',
  'supportChat.contact.field.mobilePhone': 'Teléfono móvil',
  'supportChat.contact.field.company': 'Empresa',
  'supportChat.contact.field.position': 'Cargo',
  'supportChat.contact.field.notes': 'Notas',
  'supportChat.contact.field.generic': '{field}',
  'supportChat.loadingMoreContacts': 'Cargando más contactos...',
  'supportChat.contact.noDetails': 'Sin información adicional',
  'supportChat.edit': 'Editar',
  'supportChat.delete': 'Eliminar',
  'supportChat.notAvailable': 'N/D',
  'supportChat.contact.editDrawer.subtitle': 'Editar contacto',
  'supportChat.contact.editDrawer.sectionTitle': 'Datos del contacto',
  'supportChat.contact.editTitleFallback': 'Contacto',
  'supportChat.loadingParticipants': 'Cargando participantes...',
  'supportChat.threadInfo.tab': 'Info del thread',
  'supportChat.threadInfo.noThreadSelected': 'Selecciona un thread para ver sus detalles.',
  'supportChat.threadInfo.basicSection': 'Detalles básicos',
  'supportChat.threadInfo.number': 'Número de caso',
  'supportChat.threadInfo.threadId': 'ID del thread',
  'supportChat.threadInfo.status': 'Estado',
  'supportChat.threadInfo.type': 'Tipo',
  'supportChat.threadInfo.handler': 'Manejador',
  'supportChat.threadInfo.controlMode': 'Modo de control',
  'supportChat.threadInfo.accessMode': 'Acceso',
  'supportChat.threadInfo.channelId': 'ID de canal',
  'supportChat.threadInfo.agentId': 'ID del agente',
  'supportChat.threadInfo.ownerUserId': 'ID del usuario dueño',
  'supportChat.threadInfo.created': 'Creado el',
  'supportChat.threadInfo.updated': 'Actualizado el',
  'supportChat.threadInfo.closed': 'Cerrado el',
  'supportChat.threadInfo.channelSection': 'Datos del canal',
  'supportChat.threadInfo.openAIConversation': 'ID de conversación OpenAI',
  'supportChat.threadInfo.openAIThreadId': 'ID de thread OpenAI',
  'supportChat.threadInfo.openAIConversationCount': 'Conversaciones OpenAI',
  'supportChat.threadInfo.telegramChatId': 'ID de chat Telegram',
  'supportChat.threadInfo.telegramBotId': 'ID del bot Telegram',
  'supportChat.threadInfo.telegramTopicId': 'ID del tópico Telegram',
  'supportChat.threadInfo.telegramTopicName': 'Nombre del tópico Telegram',
  'supportChat.threadInfo.noChannelData': 'Sin información adicional del canal.',
  'supportChat.threadInfo.tokensSection': 'Consumo de tokens',
  'supportChat.threadInfo.tokens.inputTokens': 'Tokens de entrada',
  'supportChat.threadInfo.tokens.cachedTokens': 'Tokens en caché',
  'supportChat.threadInfo.tokens.outputTokens': 'Tokens de salida',
  'supportChat.threadInfo.tokens.reasoningTokens': 'Tokens de razonamiento',
  'supportChat.threadInfo.tokens.totalTokens': 'Total de tokens',
  'supportChat.threadInfo.unknown': 'Desconocido',
  'supportChat.threadStatus.pending': 'Pendiente',
  'supportChat.threadStatus.active': 'Activo',
  'supportChat.threadStatus.lookingForAgent': 'Buscando agente',
  'supportChat.threadStatus.closed': 'Cerrado',
  'supportChat.threadStatus.archived': 'Archivado',
  'supportChat.threadType.generalSupport': 'Soporte general',
  'supportChat.threadHandler.none': 'Sin asignar',
  'supportChat.threadHandler.ai': 'IA',
  'supportChat.threadHandler.agent': 'Agente humano',
  'supportChat.threadControl.auto': 'Control IA',
  'supportChat.threadControl.assisted': 'Co-piloto',
  'supportChat.threadControl.humanOnly': 'Solo humano',
  'supportChat.threadControl.unknown': 'Desconocido',
  'supportChat.threadAccess.readOnly': 'Solo lectura',
  'supportChat.threadAccess.write': 'Escritura',
  'supportChat.showThreadPanel': 'Mostrar panel de información',
  'supportChat.hideThreadPanel': 'Ocultar panel de información',
  'supportChat.showRunHistory': 'Mostrar historial de ejecuciones',
  'supportChat.hideRunHistory': 'Ocultar historial de ejecuciones',

  // Error messages and missing translations
  'supportChat.connectionTimeout': 'Tiempo de espera de conexión agotado',
  'supportChat.socketNotAvailable': 'Socket no disponible',
  'supportChat.couldNotConnectToJoinChat': 'No se pudo conectar para unirse al chat',
  'supportChat.timeoutJoiningChat': 'Tiempo agotado al unirse al chat',
  'supportChat.errorJoiningChat': 'Error al unirse al chat{separator} {message}',
  'supportChat.unknownError': 'Error desconocido',
  'supportChat.scheduledTaskExecution': 'Ejecución de tarea programada',
  'supportChat.loadingConversation': 'Cargando conversación...',
  'supportChat.fileUrlNotFound':
    'No se encontró la URL del archivo. Por favor, intenta adjuntar el archivo nuevamente.',
  'supportChat.invalidFileType':
    'Tipo de archivo no permitido. Solo se permiten imágenes y audios.',
  'supportChat.uploadCancelled': 'Carga cancelada',
  'supportChat.maxAttachments': 'Máximo {max} archivos adjuntos permitidos',
  'supportChat.fileTooLarge': 'El archivo excede el tamaño máximo de {max}',
  'supportChat.retryUpload': 'Reintentar subida',
  'supportChat.uploadFailed': 'Fallo en la carga',

  // Instrucciones de Engine AI
  'supportChat.engineAiMessage.title': 'Instrucciones de Engine AI',
  'supportChat.engineAiMessage.empty': 'No hay instrucciones disponibles',

  // Email message support
  'supportChat.emailMessage': 'Mensaje de Email',
  'supportChat.from': 'De',
  'supportChat.emailFrom': 'De',
  'supportChat.emailTo': 'Para',
  'supportChat.emailCc': 'CC',
  'supportChat.collapse': 'Contraer',
  'supportChat.expand': 'Expandir',
  'supportChat.noEmailContent': 'No hay contenido de email disponible',
  'supportChat.taskDetails': 'Detalles de la Tarea',
  'supportChat.task': 'Tarea',
  'supportChat.executedAt': 'Ejecutado el {time}',
  'supportChat.executedRecently': 'Ejecutado recientemente',
  'supportChat.unknown': 'Desconocido',
  'supportChat.noOutput': 'No hay resultado disponible',
  'supportChat.runId': 'ID de Ejecución',
  'supportChat.noResponseAvailable': 'No hay respuesta disponible',

  // Task run detailed information
  'supportChat.runIdComplete': 'Run ID Completo',
  'supportChat.type': 'Tipo',
  'supportChat.finished': 'Finalizado',
  'supportChat.status': 'Estado',
  'supportChat.lastUpdate': 'Última Actualización',
  'supportChat.executionNumber': 'Número de Ejecución',
  'supportChat.started': 'Iniciado',
  'supportChat.taskId': 'Task ID',
  'supportChat.processed': 'Procesada',
  'supportChat.result': 'Resultado',
  'supportChat.connectionIssues': 'Problemas de conexión detectados - reintentando...',
  'supportChat.authenticationExpired': 'Sesión expirada - por favor, recarga la página',
  'supportChat.syncing': 'Sincronizando...',
  'supportChat.syncingThread': 'Sincronizando hilo...',
  'supportChat.reconciliationFailed': 'No se pudo sincronizar el estado del chat',

  // AI Thinking Operation Messages
  'supportChat.aiThinking.none': 'Procesando...',
  'supportChat.aiThinking.analyzingContext': 'Analizando el contexto de la conversación...',
  'supportChat.aiThinking.internalReasoning': 'Razonando internamente antes de responder...',
  'supportChat.aiThinking.toolCalling': 'Ejecutando herramientas especializadas...',
  'supportChat.aiThinking.toolCallingWithFunction': 'Ejecutando: {functionName}',
  'supportChat.aiThinking.toolCompleted': 'Listo',
  'supportChat.aiThinking.toolDetail.arguments': 'Argumentos',
  'supportChat.aiThinking.toolDetail.output': 'Output',
  'supportChat.aiThinking.toolDetail.error': 'Error',
  'supportChat.aiThinking.idleBetweenSteps': 'Preparando el siguiente paso...',
  'supportChat.aiThinking.synthesizingAnswer': 'Preparando la respuesta final...',
  'supportChat.aiThinking.errorHandling': 'Manejando un error en el proceso...',
  'supportChat.aiThinking.errorHandlingWithMessage': 'Error: {errorMessage}',
  'supportChat.aiThinking.thinkingThreadTitle': 'Generando título de la conversación...',
  'supportChat.aiThinking.preparingTaskRun': 'Preparando ejecución de la tarea...',
  'supportChat.aiThinking.downloadingFile': 'Descargando archivo generado...',
  'supportChat.aiThinking.contextRecovery': 'Recuperando contexto de la conversación...',
  'supportChat.aiThinking.reasoningOutputCommentary': 'Comentario del asistente',
  'supportChat.aiThinking.agentCalling': 'Llamando a un agente...',
  'supportChat.aiThinking.agentCalling.consulting': 'Consultando a',
  'supportChat.aiThinking.todoPlanCreated': 'Construyendo plan de acción...',
  'supportChat.aiThinking.todoItemCreated': 'Nueva tarea añadida al plan',
  'supportChat.aiThinking.todoItemCreatedWithTitle': 'Tarea añadida: {title}',
  'supportChat.aiThinking.todoItemCompleted': 'Tarea completada',
  'supportChat.aiThinking.todoItemCompletedWithTitle': 'Completada: {title}',
  'supportChat.aiThinking.preparingFileResources': 'Preparando archivos...',
  'supportChat.aiThinking.preparingFileResourcesWithCount':
    'Preparando {count, plural, one {# archivo} other {# archivos}}...',
  'supportChat.aiThinking.preparingFileResourcesWithNames':
    'Preparando {count, plural, one {# archivo} other {# archivos}}: {names}',
  'supportChat.aiThinking.fileUse.label': 'Uso: {uses}',
  'supportChat.aiThinking.fileUse.publicUrl': 'URL pública',
  'supportChat.aiThinking.fileUse.modelContext': 'Contexto del modelo',
  'supportChat.aiThinking.todoPlanTitle': 'Plan de acción',
  'supportChat.aiThinking.todoCounter': '{completed} de {total}',
  'supportChat.aiThinking.todoHeaderProgress': 'Plan de acción · {completed}/{total} tareas',
  'supportChat.aiThinking.todoStatus.pending': 'Pendiente',
  'supportChat.aiThinking.todoStatus.inProgress': 'En progreso',
  'supportChat.aiThinking.todoStatus.blocked': 'Bloqueada',
  'supportChat.aiThinking.todoStatus.onHold': 'En espera',
  'supportChat.aiThinking.todoStatus.completed': 'Completada',
  'supportChat.aiThinking.todoStatus.canceled': 'Cancelada',
  'supportChat.aiThinking.todoStatus.failed': 'Fallida',

  // AI Thinking Timeline Messages
  'supportChat.aiTimeline.thinking': 'Pensando...',
  'supportChat.aiTimeline.thoughtProcess': 'Proceso de pensamiento',
  'supportChat.aiTimeline.steps': '{count} pasos',
  'supportChat.aiTimeline.inProgress': 'en progreso',
  'supportChat.aiTimeline.detail': 'Ver detalle',
  'supportChat.aiTimeline.durationSeconds': '{seconds}s',
  'supportChat.aiTimeline.durationMinutes': '{minutes}m',
  'supportChat.aiTimeline.durationMinutesSeconds': '{minutes}m {seconds}s',

  // Thread Participants
  'supportChat.participants.title': 'Participantes del Thread',
  'supportChat.participants.empty': 'No hay participantes en este thread',
  'supportChat.participants.addSuccess': 'Participante agregado exitosamente',
  'supportChat.participants.addError': 'Error al agregar participante',
  'supportChat.participants.removeSuccess': 'Participante eliminado exitosamente',
  'supportChat.participants.removeError': 'Error al eliminar participante',
  'supportChat.participants.updateSuccess': 'Permisos actualizados exitosamente',
  'supportChat.participants.updateError': 'Error al actualizar permisos',
  'supportChat.participants.confirmRemove.title': 'Eliminar Participante',
  'supportChat.participants.confirmRemove.content':
    '¿Estás seguro de que deseas eliminar a {userName} de este thread?',
  'supportChat.participants.editAccess': 'Editar permisos de acceso',
  'supportChat.participants.remove': 'Eliminar participante',
  'supportChat.participants.addedOn': 'Agregado el',

  // Access Modes
  'supportChat.participants.accessMode.label': 'Acceso',
  'supportChat.participants.accessMode.readonly': 'Solo lectura',
  'supportChat.participants.accessMode.write': 'Escritura',
  'supportChat.participants.accessMode.readonlyDesc': 'Puede ver mensajes pero no puede escribir',
  'supportChat.participants.accessMode.writeDesc': 'Puede ver y escribir mensajes',

  // Assignment Modes
  'supportChat.participants.assignmentMode.userInitiated': 'Agregado por usuario',
  'supportChat.participants.assignmentMode.adminAssigned': 'Asignado por administrador',
  'supportChat.participants.assignmentMode.systemAssigned': 'Asignado por sistema',
  'supportChat.participants.assignmentMode.manualAssignment': 'Asignación manual',

  // Share Thread Modal
  'supportChat.share.title': 'Compartir Thread',
  'supportChat.share.description': 'Comparte este thread con otros usuarios para colaborar',
  'supportChat.share.selectUser': 'Seleccionar usuario',
  'supportChat.share.selectUsers': 'Seleccionar usuarios',
  'supportChat.share.userRequired': 'Debes seleccionar un usuario',
  'supportChat.share.usersRequired': 'Debes seleccionar al menos un usuario',
  'supportChat.share.userPlaceholder': 'Buscar usuario por nombre...',
  'supportChat.share.newParticipant': 'Nuevo participante',
  'supportChat.share.selectedUsers': 'Usuarios seleccionados',
  'supportChat.share.accessMode': 'Tipo de acceso',
  'supportChat.share.selected': 'Seleccionado',
  'supportChat.share.addParticipant': 'Agregar Participante',
  'supportChat.share.addParticipants': 'Agregar {count} Participantes',
  'supportChat.participants.addMultipleSuccess': '{count} participantes agregados exitosamente',
  'supportChat.participants.addMultipleError': 'Error al agregar {count} participantes',
  'supportChat.participants.currentParticipants': 'Participantes actuales',
  'supportChat.participants.loading': 'Cargando participantes...',
  'supportChat.participants.noParticipants': 'No hay participantes en esta conversación',
  'supportChat.participants.unknownUser': 'Usuario desconocido',
  'supportChat.participants.changeAccessSuccess': 'Permisos de acceso actualizados exitosamente',
  'supportChat.participants.changeAccessError': 'Error al actualizar permisos de acceso',
  'supportChat.participants.removeSuccess': '{name} eliminado de la conversación exitosamente',
  'supportChat.participants.removeError': 'Error al eliminar {name} de la conversación',
  'supportChat.participants.changeAccessTo': 'Cambiar a {mode}',
  'supportChat.participants.remove': 'Eliminar de la conversación',
  'supportChat.participants.accessShort': 'Acceso',
  'supportChat.participants.removeShort': 'Eliminar',
  'supportChat.participants.title': 'Participantes',
  'supportChat.participants.defaultThreadTitle': 'Conversación de Soporte',
  'supportChat.participants.drawerSubtitle': 'Gestionar acceso y colaboradores',
  'supportChat.participants.addNew': 'Agregar Participantes',

  // Acciones de Conversación
  'supportChat.threadActions.participants': 'Ver participantes',
  'supportChat.threadActions.share': 'Compartir',
  'supportChat.takeConversation': 'Tomar conversación',
  'supportChat.releaseConversation': 'Liberar conversación',
  'supportChat.takeConversation.success': 'Ahora controlas esta conversación',
  'supportChat.takeConversation.error': 'No se pudo tomar la conversación',
  'supportChat.releaseConversation.success': 'Control devuelto a la IA',
  'supportChat.releaseConversation.error': 'No se pudo liberar la conversación',
  'supportChat.tasks': 'Tareas',

  // Process Instance
  'supportChat.viewRequest': 'Ver solicitud',

  // Search
  'supportChat.searchThreads': 'Buscar conversaciones...',
};
